<template>
  <component
    :is="href ? 'a' : to ? 'router-link' : 'button'"
    :target="newWindow ? '_blank' : undefined"
    :href="!disabled ? href : ''"
    :to="to"
    :class="`btn btn-${variant} ${size ? 'btn-' + size : ''} ${
      fullWidth ? 'w-100' : ''
    } ${isLoading ? 'spinner spinner-light spinner-right' : ''}`"
    :disabled="disabled"
    @click="$emit('click', $event)"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
      default: "primary"
    },
    size: {
      type: String,
      default: "lg"
    },
    fullWidth: Boolean,
    isLoading: Boolean,
    href: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    newWindow: Boolean,
    disabled: Boolean
  }
};
</script>
